import React from 'react';
import { AdminListWrapper, TableCell } from 'components/Hospital/PaginationForms';
import { adminCounselerListWidth } from 'constants/pagination';
import { AdminCounselerListPaginationTableProps } from 'models/Admin/AdminPaginationTypes';
import BasicButton from 'components/Buttons/BasicButton';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import { getWidthRation } from 'utils/calculateWdith';
import { changeMobileForm } from 'utils/changeMobileForm';
import IcCalendar from 'assets/Icons/Calendar/IcCalendar';

const AdminCounselerListPaginationTable = ({ currentData, totalCount, currentPage, clickScheduleManageButton }: AdminCounselerListPaginationTableProps) => {
    const itemsPerPage = 11;

    return (
        <>
            {currentData?.map((item, idx) => {
                const itemNumber = totalCount - (currentPage - 1) * itemsPerPage - idx;
                return (
                    <AdminListWrapper key={idx}>
                        <TableCell $width={getWidthRation(adminCounselerListWidth[0])} $type='no'>
                            {itemNumber}
                        </TableCell>
                        <TableCell $width={getWidthRation(adminCounselerListWidth[1])} $type='name'>
                            {item.hospitalName}
                        </TableCell>
                        <TableCell $width={getWidthRation(adminCounselerListWidth[2])}>{item.email}</TableCell>
                        <TableCell $width={getWidthRation(adminCounselerListWidth[3])}>
                            <NameWrapper>
                                {item.name}
                                {item.existSchedule && (
                                    <Tooltip title='스케줄 생성되어 있음' arrow>
                                        <div>
                                            <IcCalendar width='16' height='16' />
                                        </div>
                                    </Tooltip>
                                )}
                            </NameWrapper>
                        </TableCell>
                        <TableCell $width={getWidthRation(adminCounselerListWidth[4])}>{changeMobileForm(item.mobile)}</TableCell>
                        <TableCell $width={getWidthRation(adminCounselerListWidth[5])} $padding='8px 14px' $justifyContent='space-between' $gap='6px'>
                            <ButtonWrapper>
                                <BasicButton $type='fill' $height='40px' $width='calc(50% - 4px)' $fontSize='14px' onClick={() => clickScheduleManageButton(item, 'batch')}>
                                    주간 일괄설정
                                </BasicButton>
                                <BasicButton disabled $type='fill' $height='40px' $width='calc(50% - 4px)' $fontSize='14px' onClick={() => clickScheduleManageButton(item, 'unit')}>
                                    개별 설정
                                </BasicButton>
                            </ButtonWrapper>
                        </TableCell>
                    </AdminListWrapper>
                );
            })}
        </>
    );
};

export default AdminCounselerListPaginationTable;

const ButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 8px;
`;

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
